import { Controller } from "@hotwired/stimulus"
import { createElement } from "../helpers"

export default class extends Controller {
  static values = { url: String }

  async open(event) {
    event.preventDefault()
    await (this.loaded ??= this.load())
    window.Beacon?.("open")
  }

  async load() {
    if (!this.urlValue) return

    const response = await fetch(this.urlValue, { headers: { Accept: "text/html; fragment" } })
    if (!response.ok) return

    const template = createElement("template", { innerHTML: await response.text() })
    for (const script of template.content.querySelectorAll("script")) {
      document.head.append(activateScriptElement(script))
    }
  }
}

// Scripts parsed from HTML are marked "already started" and never run, and
// clones inherit that mark, so a fresh element is built the way Turbo does it.
// async=false keeps scripts with a src executing in document order.
function activateScriptElement(element) {
  const script = createElement("script", { textContent: element.textContent, async: false })
  for (const { name, value } of element.attributes) {
    script.setAttribute(name, value)
  }
  return script
}
